import React, { useMemo } from "react";
import get from "lodash/get";
import { helpers } from "services";
import useTranslation from "hooks/useTranslation";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { rowClassName } from "utils";

const CashRegister = ({ data }) => {
  const { tr } = useTranslation();
  const authStore = useSelector(state => state.auth);
  const defaultCurrency = get(authStore, "default_currency_code");

  const ordersByFilialTableData = useMemo(() => {
    const otranizationsWithChildren = get(data, "organizations", []).map(organization => {
      if (get(organization, "cashiers", []).length > 0) {
        organization.cashiers.forEach(cashier => {
          cashier.children = get(cashier, "payments", []).map(payment => {
            return {
              ...payment,
              total: {
                income: get(payment, "income"),
                expense: get(payment, "expense"),
                balance: get(payment, "balance"),
              },
            };
          });
        });
      }

      if (get(organization, "cashiers", []).length > 0) {
        organization.children = get(organization, "cashiers", []);
      }

      return organization;
    });

    try {
      otranizationsWithChildren.unshift({
        name: "Итого",
        total: {
          income: get(data, "total.income", 0),
          expense: get(data, "total.expense", 0),
          balance: get(data, "total.balance", 0),
        },
      });
    } catch (error) {
      console.log(error);
    }

    return otranizationsWithChildren;
    // No need to check whole data, if some state changes then it will definitely be seen in total
  }, [get(data, "total")]);

  return (
    <Table
      bordered
      size="middle"
      dataSource={ordersByFilialTableData}
      pagination={false}
      rowClassName={rowClassName()}
      columns={[
        {
          title: tr("Филиалы"),
          dataIndex: "name",
          width: 300,
        },
        {
          title: tr("Приход"),
          dataIndex: "income",
          align: "right",
          render(value, record, idx) {
            return (
              <span>
                {helpers.convertToReadable(+get(record, "total.income", 0))} {defaultCurrency.toUpperCase()}
              </span>
            );
          },
        },
        {
          title: tr("Расход"),
          align: "right",
          render(value, record, idx) {
            return (
              <span>
                {helpers.convertToReadable(+get(record, "total.expense", 0))} {defaultCurrency.toUpperCase()}
              </span>
            );
          },
        },
        {
          title: tr("Остаток"),
          align: "right",
          render(value, record, idx) {
            return (
              <span>
                {helpers.convertToReadable(+get(record, "total.balance", 0))} {defaultCurrency.toUpperCase()}
              </span>
            );
          },
        },
      ]}
      rowKey={row => row.id}
    />
  );
};

export default CashRegister;
